module.exports = __webpack_public_path__ + "img/nanfashi.6f60b784.png";